import { createChildListViewContainer } from 'factories/ChildListView'
import Component from 'components/DraftOrder/Items'

export default createChildListViewContainer()(Component)
